import { size } from "lodash-es";
import json from "vue-resource/src/http/interceptor/json";

export default {
  municipiosFilteredsCount: ({ municipiosFiltereds }) => size(municipiosFiltereds),
  municipios: ({ municipios }) => municipios,
  municipiosFiltereds: ({ municipiosFiltereds }) => municipiosFiltereds,
  isLoading: ({ isLoading }) => isLoading,
  error: ({ error }) => error,
  latestClicked: ( { latestClicked }) => (latestClicked.codigo_ibge) ? latestClicked : JSON.parse(localStorage.getItem('latestClicked'))
}
